/**
 * theme.js - Design System Constants
 * Phase 3B - Named exports only
 */

export const COLORS = {
  brand: '#4338CA',
  brandLight: '#6366F1',
  slate900: '#0F172A',
  slate700: '#334155',
  slate500: '#64748B',
  slate300: '#CBD5E1',
  slate100: '#F1F5F9',
  slate50: '#F8FAFC',
  amber: '#F59E0B',
};

export const POSITION_COLORS = {
  QB: '#6366F1',
  RB: '#0EA5E9',
  WR: '#8B5CF6',
  TE: '#06B6D4',
  FLEX: '#F59E0B',
};

export const TEAM_COLORS = {
  KC: '#E31837',
  BUF: '#00338D',
  BAL: '#241773',
  PHI: '#004C54',
  DAL: '#003594',
  MIA: '#008E97',
  DET: '#0076B6',
  HOU: '#03202F',
  LV: '#000000',
  CLE: '#FF3C00',
  TEN: '#4B92DB',
  CIN: '#FB4F14',
  SEA: '#002244',
  LAR: '#003594',
  SF: '#AA0000',
  ARI: '#97233F',
  GB: '#203731',
  MIN: '#4F2683',
  CHI: '#0B162A',
  NYG: '#0B2265',
  WAS: '#773141',
  ATL: '#A71930',
  CAR: '#0085CA',
  NO: '#D3BC8D',
  TB: '#D50A0A',
  DEN: '#FB4F14',
  LAC: '#0080C6',
  PIT: '#FFB612',
  IND: '#002C5F',
  JAX: '#006778',
  NE: '#002244',
  NYJ: '#125740',
};

export const PLAYER_COLORS = ['#4F46E5', '#0891B2', '#7C3AED'];
